import { faLock, faUnlock } from '@fortawesome/pro-regular-svg-icons';
import { faUnlock as faUnlockSolid } from '@fortawesome/pro-solid-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { usePermissions } from 'contexts/PermissionsContext';
import { sdClient } from 'contexts/SDKClientContext';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import { tokens } from 'styles/tokens';

export function UserLockedOutCell({ rowData, onChange }: UsersTableCellProps) {
    const { canUnlockUser } = usePermissions();

    const onSave = async () => {
        try {
            await sdClient.unlockUser({ userId: rowData.Id });
            onChange();
        } catch {
            return 'Unable to save setting for locked status';
        }
        return undefined;
    };

    return (
        <HoverIconButton
            title={
                rowData.LockedOut
                    ? `User is locked out.${canUnlockUser ? ' Click to unlock.' : ''}`
                    : 'User is unlocked.'
            }
            icon={rowData.LockedOut ? faLock : faUnlockSolid}
            hoverIcon={faUnlock}
            color={tokens.text.primary}
            onClick={rowData.LockedOut ? onSave : undefined}
            disabled={!rowData.LockedOut || !canUnlockUser}
        />
    );
}
